var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSpeechBubble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5286 8.12113C60 11.0089 60 14.7893 60 22.35V26.65C60 34.2107 60 37.9911 58.5286 40.8789C57.2343 43.4191 55.1691 45.4843 52.6289 46.7786C51.3634 47.4234 49.9266 47.7856 48.0754 47.9891L48.1499 54.5149C48.1933 58.3211 43.6242 60.2918 40.8857 57.6479L31.1516 48.25H21.6C14.0393 48.25 10.2589 48.25 7.37113 46.7786C4.83094 45.4843 2.7657 43.4191 1.47141 40.8789C0 37.9911 0 34.2107 0 26.65V22.35C0 14.7893 0 11.0089 1.47141 8.12113C2.7657 5.58094 4.83094 3.5157 7.37113 2.22141C10.2589 0.75 14.0393 0.75 21.6 0.75H38.4C45.9607 0.75 49.7411 0.75 52.6289 2.22141C55.1691 3.5157 57.2343 5.58094 58.5286 8.12113Z",
    fill: "#FFC800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7748 21.4835L13.7748 17.0402C13.7748 15.6171 13.8429 15.2749 14.0325 14.9308C14.1472 14.7225 14.2953 14.5788 14.508 14.4684C14.8581 14.2866 15.2052 14.2216 16.6661 14.2216L23.1124 14.2216C24.9281 14.2216 26.3999 12.7981 26.3999 11.0422C26.3999 9.28629 24.9281 7.86284 23.1124 7.86284H16.6661C14.2094 7.86284 12.8334 8.12079 11.3982 8.86589C10.04 9.57102 8.95517 10.6241 8.22978 11.9408C7.46458 13.3298 7.1999 14.6603 7.1999 17.0402V21.4835C7.1999 23.2394 8.67175 24.6628 10.4874 24.6628C12.303 24.6628 13.7748 23.2394 13.7748 21.4835Z",
    fill: "#FFE27B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpeechBubble);
export default __webpack_public_path__ + "static/media/icon-speech-bubble.96fec1606321e3b7ad4408aaf151da07.svg";
export { ForwardRef as ReactComponent };